import { useParams } from 'react-router-dom';

import { UserComponent } from 'pages/keys/components/user/user.component';
const KOL = () => {
  const { id } = useParams();
  //render
  return <UserComponent user_address={id} />;
};
export default KOL;
